export default {"src":"/_next/static/media/2.85a98426.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};